export default __webpack_public_path__ + "static/media/img-37.ae908e7f.jpg";